export const environment = {
  production: false,
  environmentName: 'development',
  showEnvironmentBanner: true,
  environmentBannerLabel: 'Development environment',
  environmentBannerTone: 'development',
  apiUrl: 'https://dev-api.samonln.com/api',

  appName: 'SamOb',
  oidcClientId: 'c5624d4d-a195-49f2-ab2c-ff5e4d79fc5e',
  oidcAuthority: 'https://login.microsoftonline.com/6f12af3a-fb33-4321-8ea0-f25343551a3e/v2.0',
  oidcRedirectUri: 'https://dev.samonln.com/auth/callback',
  oidcPostLogoutRedirectUri: 'https://dev.samonln.com/login',
  oidcScope: 'openid profile email api://c5624d4d-a195-49f2-ab2c-ff5e4d79fc5e/access_as_user',
};
